export default __webpack_public_path__ + "static/media/link.0a968c53.svg";